import styled, { css } from 'styled-components';

import { ThemeType } from '../../theme';

export type StyleProps = {
  variant?:
    | 'primary'
    | 'danger'
    | 'secondary'
    | 'gray'
    | 'white'
    | 'nostyle'
    | 'cancel';
  size?: 'sm' | 'md' | 'xs' | 'xl' | 'lg';
  $bgColor?: string;
  color?: string;
  $outline?: boolean;
  width?: string;
};
const getBackgroundColor = (
  variant: string,
  outline: boolean,
  theme: ThemeType,
  bgColor?: string
) => {
  if (bgColor) {
    return bgColor;
  }
  if (outline) {
    return theme.colors.white;
  }
  switch (variant) {
    case 'primary':
      return theme.colors.primary;
    case 'secondary':
      return theme.colors.secondary;
    case 'gray':
      return theme.colors.defaultButton;
    case 'danger':
      return theme.colors.red.strong;
    case 'white':
      return theme.colors.white;
    case 'cancel':
      return theme.colors.disableText;
    default:
      return theme.colors.blue.faded;
  }
};

const getSize = (size?: string) => {
  switch (size) {
    case 'xs':
      return css`
        font-size: 12px;
        height: 32px;
      `;
    case 'sm':
      return css`
        font-size: 14px;
        height: 36px;
      `;
    case 'md':
      return css`
        font-size: 16px;
        height: 39px;
      `;
    case 'lg':
      return css`
        font-size: 16px;
        height: 45px;
      `;
    default:
      return css`
        font-size: 16px;
        height: 36px;
      `;
  }
};

const getColor = (
  variant: string,
  outline: boolean,
  theme: ThemeType,
  color: string
) => {
  if (color) {
    return color;
  }
  if (!outline && variant !== 'gray' && variant !== 'white') {
    return theme.colors.white;
  }
  switch (variant) {
    case 'gray':
      return theme.colors.disableButtonText;
    case 'primary':
      return theme.colors.primary;
    case 'secondary':
      return theme.colors.secondary;
    case 'danger':
      return theme.colors.red.strong;

    default:
      return theme.colors.black;
  }
};

const buttonStyleSelector = (
  variant: string,
  outline: boolean,
  bgColor: string,
  color: string
) => {
  return css`
    background-color: ${({ theme }) =>
      getBackgroundColor(variant, outline, theme, bgColor)};
    color: ${({ theme }) => getColor(variant, outline, theme, color)};
    border: 2px solid
      ${({ theme }) =>
        outline
          ? getColor(variant, outline, theme, color)
          : getBackgroundColor(variant, outline, theme, bgColor)};
  `;
};

export const StyledButton = styled.button<StyleProps>`
  margin: 0;
  padding: 0;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  justify-content: center;
  box-sizing: border-box;
  width: ${({ width }) => width};
  min-width: fit-content;
  padding: 0px 10px;
  gap: 10px;
  ${({ size }) => getSize(size)};
  ${({ variant, $outline, $bgColor, color }) =>
    buttonStyleSelector(
      variant || 'primary',
      $outline || false,
      $bgColor || '',
      color || ''
    )};

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  ${({ variant }) =>
    variant === 'nostyle'
      ? css`
          all: unset;
          color: inherit;
          font: inherit;
          cursor: pointer;
          outline: inherit;
        `
      : css``}
`;
